export interface ProjectLeader {
  firstName: string;
  lastName: string;
  role: string;
}
